import { gql } from "@apollo/client";

import { OrganizationMemberFragment } from "./get-organization-members-query";

export default gql`
  ${OrganizationMemberFragment}
  mutation updateMemberMutation(
    $organizationId: Int!
    $role: OrganizationRole
    $userId: Int!
    $startDate: String
    $employeeId: String
    $position: String
    $location: String
    $membershipStatus: AccountToOrganizationMembershipStatus
    $addLedTeamIds: [Int!]
    $removeLedTeamIds: [Int!]
  ) {
    updateOrganizationMembership(
      organizationId: $organizationId
      userId: $userId
      role: $role
      startDate: $startDate
      employeeId: $employeeId
      position: $position
      location: $location
      membershipStatus: $membershipStatus
      addLedTeamIds: $addLedTeamIds
      removeLedTeamIds: $removeLedTeamIds
    ) {
      member {
        ...OrganizationMember
      }
    }
  }
`;
